import axios from "axios";

import { API_TIMEOUT } from "@/v1/config/constants";

const restclientLaunch = axios.create({
  baseURL: process.env.REACT_APP_LAUNCH_API,
  timeout: API_TIMEOUT,
});

export default restclientLaunch;
